import { sendToCustomerDisplay } from '@/helpers/cdPusherHelper';

const getSubdomainFromBaseUrl = (baseUrl) => {
    if (!baseUrl || typeof baseUrl !== 'string') return '';

    try {
        const host = baseUrl.split('//')[1] || '';
        return (host.split('.')[0] || '').trim();
    } catch (e) {
        return '';
    }
};

const state = () => ({
    isEnabled: localStorage.getItem('cd_enabled') === 'true'
});

// getters
const getters = {
    isConnected: (state) => state.isEnabled,
    isEnabled: (state) => state.isEnabled
};

// mutations
const mutations = {
    SET_IS_ENABLED(state, status) {
        state.isEnabled = status;
        localStorage.setItem('cd_enabled', status);
    }
};

// actions
const actions = {
    sendMessage: async ({state, rootState}, message) => {
        if (!state.isEnabled) {
            return;
        }

        const terminal = rootState.config.terminal;
        const baseUrl = rootState.config.baseUrl || localStorage.getItem('baseUrl');
        const subdomain = terminal?.domain_name || getSubdomainFromBaseUrl(baseUrl);
        const terminalId = terminal?.id;

        if (!subdomain || !terminalId) {
            console.warn('[CustomerDisplay] Not sending (missing channel parts)', {
                subdomain,
                terminalId,
                terminal
            });
            return;
        }

        await sendToCustomerDisplay(subdomain, terminalId, message);
    },
    setIsEnabled: ({ commit, dispatch, rootGetters }, status) => {
        commit('SET_IS_ENABLED', status);
        if (status) {
            dispatch('sendMessage', { whitelabel: rootGetters['config/whitelabelSettings'] });
        }
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
